import { Breadcrumbs, LoadingBox, PageLayout, Rate } from 'components'
import {
  useGetProductCustomActions,
  useGetProductInitialValues
} from 'domains/Product/hooks'
import { useLoading, useTranslations } from 'hooks'
import { useNavigate, useParams } from 'react-router-dom'

import { COLLECTIONS } from '__constants__'
import { ProductAdvancedView } from 'domains/Product/components'
import PropTypes from 'prop-types'
import { useMemo } from 'react'

const MyProductShow = (props) => {
  const { isRentee } = props
  const { t } = useTranslations()
  const navigate = useNavigate()
  const { productId } = useParams()
  const [initialValues, initialValuesLoading] =
    useGetProductInitialValues(productId)

  const actions = useGetProductCustomActions({
    layout: 'vertical',
    productId: productId,
    isRentee,
    product: initialValues?.product
  })

  const handleBack = () => navigate(-1)
  const loading = useLoading([initialValuesLoading])

  const headerSubtitle = useMemo(
    () => <Rate type="advanced" value={initialValues?.rating} />,
    [initialValues?.rating]
  )

  const headingProps = !loading && {
    title: initialValues?.product?.name || t('Product show'),
    marginBottom: 4,
    textAlign: 'left',
    subTitle: headerSubtitle,
    actions: actions
  }

  return (
    <PageLayout
      onBack={handleBack}
      breadcrumbs={<Breadcrumbs collection={COLLECTIONS.PRODUCTS} />}
      headingProps={headingProps}
      area="product">
      <LoadingBox
        loading={loading}
        spinnerProps={{ text: t('Product loading') }}>
        <ProductAdvancedView {...initialValues} />
      </LoadingBox>
    </PageLayout>
  )
}

MyProductShow.propTypes = {
  isRentee: PropTypes.bool
}

export default MyProductShow
